import { FC } from 'react'
import { useHistory } from 'react-router-dom'
import { IonButton } from '@ionic/react'

import { UGC } from '@/components/atoms/assets/UGC'

import { Tracking, TrackingEvent } from '@/lib/tracking'
import { Routes } from '@/router/routes'
import { isNative } from '@/utils/utils'

import { ugcComposer } from '@/plugins/ugc-composer'

export const UGCButton: FC = () => {
  const history = useHistory()

  return (
    <IonButton
      className="large"
      color="plain"
      onClick={async (e) => {
        Tracking.triggerEvent(TrackingEvent.AddContentStarted)
        e.stopPropagation()

        if (isNative()) {
          const result = await ugcComposer()

          if (result?.media?.url) {
            history.push({
              pathname: Routes.POST,
              state: {
                media: {
                  url: result?.media?.url,
                  ratio: result?.media?.ratio,
                  mimeType: result?.media?.mimeType,
                  mediaType: result?.media?.mediaType,
                },
              },
            })
          }
        } else {
          history.push(Routes.POST)
        }
      }}
    >
      <UGC className="min-w-[3.5rem]" />
    </IonButton>
  )
}
